import { masters } from "@nexseed/shared";
import { HardHat } from "lucide-react";
import { defineMaster, type MasterRow } from "../spec";

/**
 * Operator Master (user, 2026-10-27; 0162): the plant's machine operators, out of Resource Master,
 * each on the Processing or Packing team. A slip's Operator Name lists its team only: Processing
 * Slip the Processing team, WB Packing Slip the Packing team, Processing and Packing Slip both.
 */
const teamLabel = (t: unknown) =>
  masters.OPERATOR_TEAM_LABELS[t as masters.OperatorTeam] ?? "—";

export const operators = defineMaster({
  key: "operators",
  title: "Operator Master",
  singular: "Operator",
  description:
    "The plant's machine operators and their team. The Processing Slip lists the Processing team, the WB Packing Slip the Packing team, the Processing and Packing Slip both.",
  icon: HardHat,
  schema: masters.operator.create,
  searchPlaceholder: "Search code or name",
  defaultSort: "code",
  listFilter: {
    param: "team",
    label: "Team",
    allLabel: "All teams",
    options: masters.OPERATOR_TEAMS.map((t) => ({
      value: t,
      label: masters.OPERATOR_TEAM_LABELS[t],
    })),
  },
  // Name only in pickers: the OP code means nothing to the floor (user, 2026-11-02).
  optionLabel: (r: MasterRow) => String(r.name ?? r.code),
  columns: [
    { id: "code", header: "Code", kind: "mono", sortable: true },
    { id: "name", header: "Name", sortable: true },
    {
      id: "team",
      header: "Team",
      sortable: true,
      cell: (r: MasterRow) => teamLabel(r.team),
    },
    {
      id: "facilityId",
      header: "Plant",
      kind: "reference",
      reference: "facilities",
      sortable: true,
    },
    { id: "isActive", header: "Status", kind: "status" },
  ],
  fields: [
    {
      name: "facilityId",
      label: "Plant",
      type: "reference",
      master: "facilities",
      required: true,
      colSpan: 2,
    },
    {
      name: "code",
      label: "Code",
      type: "text",
      transform: "upper",
      required: true,
      description: "OP-01, OP-02…",
    },
    { name: "name", label: "Name", type: "text", required: true },
    {
      name: "team",
      label: "Team",
      type: "enum",
      required: true,
      options: masters.OPERATOR_TEAMS.map((t) => ({
        value: t,
        label: masters.OPERATOR_TEAM_LABELS[t],
      })),
      colSpan: 2,
    },
    { name: "isActive", label: "Active", type: "switch" },
  ],
});
